<template>
  <div class="no-print containerToolbar">
    <v-app-bar color="white" class="toolbar__content elevation-0 px-0 px-sm-5">
      <div class="pr-5 d-lg-none d-xl-none">
        <v-btn icon class="toolbar__button-icon" @click.stop="$emit('click')">
          <v-icon>
            fa-bars
          </v-icon>
        </v-btn>
      </div>

      <slot>
        <TheBreadcrumb
          :items="$route.meta.breadcrumb"
          class="d-none d-sm-flex"
        />
      </slot>

      <v-spacer class="d-none d-sm-flex" />
      <div class="pr-5 pl-5 pl-sm-0">
        <v-btn icon class="toolbar__button-icon" v-if="userIsGuest">
          <img
            src="@/assets/ic_head_notificacoes.svg"
            alt="Botão de notificações"
          />
        </v-btn>
      </div>
      <div class="toolbar__border pr-5" />
      <v-btn
        class="mr-2 toolbar__button-photo"
        fab
        width="auto"
        height="auto"
        @click="goToMyInfo()"
        :disabled="userIsGuest"
      >
        <v-avatar size="32">
          <img
            :src="profile.photo"
            alt="Foto do usuário"
            class="toolbar__avatar"
          />
        </v-avatar>
      </v-btn>
      <v-toolbar-title
        class="toolbar__username gray--text d-none d-sm-flex pr-5"
      >
        {{ profile.name }}
      </v-toolbar-title>
      <div class="toolbar__border pr-5" />
      <v-btn icon @click="goToLogin()" class="toolbar__button-icon">
        <img src="@/assets/ic_head_logout.svg" alt="Botão de sair do sistema" />
      </v-btn>
    </v-app-bar>
    <v-divider />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { TokenService } from "@/api/storage.js";
export default {
  mixins: [LoadingRequest],
  props: {
    requestUserData: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState("me", ["myInfo", "userIsGuest"]),
    profile() {
      return {
        name: this.myInfo.nickname || "",
        photo: this.myInfo.avatar?.url || require("@/assets/blank_profile.svg")
      };
    }
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapActions("me", ["requestMyInfo"]),
    goToLogin() {
      this.logout();
      this.$router.push({ name: "login" });
    },
    goToMyInfo() {
      this.$router.push({ name: "me" });
    },
    fetchData() {
      if (this.requestUserData) {
        this.requestMyInfo().then(data => {
          let photo = data.avatar?.url || require("@/assets/blank_profile.svg");
          TokenService.savePhotoInfo(photo);
        });
      }
    }
  },
  mounted() {
    if (!this.userIsGuest) {
      this.fetchData();
    }
  }
};
</script>
<style lang="sass">
.containerToolbar
  min-width: 100% !important
  margin: 0 auto
  align-items: center
.v-toolbar__content
  padding: 4px 0px
  @media(max-width:1260px)
    padding: 4px 0px
.toolbar__
  &content
    z-index: 6
    height: 70px
    align-items: center
    box-shadow: 0 0 15px 0 rgba(0,0,0,0.1) !important
  &shadow
    height: 80px
  &button-photo
    box-shadow: none
    background-color: white !important
  &button-icon
    width: 24px !important
  &username
    font-size: 14px
    font-weight: 500
  &border
    border-left: 1px solid #CED4F5
    box-sizing: border-box
    height: 29px
    width: 1px
  &avatar
    object-fit: cover
@media print
  .no-print
    display: none
</style>
